/**
 * Counts unread Messenger threads for the signed-in user.
 * A thread is a `smsNotifications/{userId}/{donorId}` key whose value is `> 0`.
 *
 * @param inbox map from donor id to incrementer, or null/undefined
 * @returns number of unread threads
 */
export function countUnreadThreads(
  inbox: { [donorId: string]: number } | null | undefined
): number {
  if (!inbox || typeof inbox !== "object") {
    return 0;
  }
  return Object.values(inbox).filter(value => {
    const n = typeof value === "number" ? value : Number(value);
    return Number.isFinite(n) && n > 0;
  }).length;
}
